export const getRegionsNameByCode = (list, baseList) => {
  return list.map((code) => {
    const obj = baseList.find((o) => o.code === code);
    if (obj !== undefined) {
      return obj.name;
    }
  });
};
